import React, { KeyboardEvent, ChangeEvent, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import Swal from 'sweetalert2';
import Menu from '../../Components/Menu';
import { API_Password_Customer } from '../../Utils/api';

interface ItemStruct {
    id_customer: string
    password_new: string
    password_confirm: string
}

const Customer_Password = () => {

    const param = useParams<{
        id: string
    }>();

    const history = useHistory();

    const Data = useRef<ItemStruct>({
        id_customer: param.id,
        password_new: '',
        password_confirm: '',
    });

    const [Error, setError] = useState({
        password_new: false as boolean,
        password_confirm: false as boolean,
    });


    const onEnter = (event : KeyboardEvent<HTMLInputElement>) : void => {
        event.key === 'Enter' && onSubmitData()
    }

    const onSubmitData = () : void => {
        if (
            CheckPassword() &&
            CheckConfirm()
        ) {
            Swal.fire({
                icon: 'warning',
                title: 'คำเตือน',
                text: 'คุณต้องการที่จะเปลื่ยนรหัสผ่าน ใช่ หรือ ไม่?',
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'ใช่',
                cancelButtonText: 'ไม่',
            }).then(result => {
                if (result.value) {
                    PostData();
                }
            });
        }
    }

    const PostData = () : void => {
        API_Password_Customer(Data.current.id_customer, Data.current.password_confirm).then(res => {
            Swal.fire({
                icon: res.status ? 'success' : 'error',
                title: res.status ? 'สำเสร็จ' : 'เกิดข้อผิดพลาด',
                text: res.message,
                timer: 5000,
                timerProgressBar: true,
            }).then(() => {
                if (res.status) {
                    history.push('/customer');
                }
            });
        }).catch(() => {
            Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาด',
                text: 'ไม่สามารถเชื่อมต่อฐานข้อมูลได้',
                timer: 5000,
                timerProgressBar: true,
            });
        });
    }

    const onChangeData = (event : ChangeEvent<HTMLInputElement>) : void => {
        const data = {
            ...Data.current,
            [event.target.id]: event.target.value
        };
        Data.current = data;
    }

    const CheckPassword = () => {
        if (Data.current.password_new.length >= 10) {
            setError(preState => ({
                ...preState,
                password_new: false
            }));
            return true;
        } else {
            setError(preState => ({
                ...preState,
                password_new: true
            }));
            document.getElementById("password_new")?.focus();
            return false;
        }
    }

    const CheckConfirm = () => {
        let status = false;
        if (Data.current.password_confirm.length >= 10) {
            if (Data.current.password_confirm === Data.current.password_new) {
                status = true;
            }
        }

        if (status) {
            setError(preState => ({
                ...preState,
                password_confirm: false
            }));
            return true;
        } else {
            setError(preState => ({
                ...preState,
                password_confirm: true
            }));
            document.getElementById("password_confirm")?.focus();
            return false;
        }
    }

    return (
        <div className="is-flex" style={{gap: '10px'}}>
            <Menu />
            <div className="p-2 container">
                <h5 className="subtitle is-5 mt-3 mb-3">จัดการกับลูกค้า / เปลื่ยนรหัสผ่านลูกค้า</h5>
                <div className="card">
                    <div className="card-content">
                        <div className="field">
                            <label className="label">รหัสผ่านใหม่</label>
                            <div className="control">
                                <input onKeyPress={onEnter} id="password_new" onChange={onChangeData} 
                                className={`input ${Error.password_new ? 'is-danger': ''}`} type="password" placeholder="รหัสผ่านใหม่ของท่าน" />
                            </div>
                        </div>
                        <div className="field">
                            <label className="label">ยืนยันรหัสผ่าน</label>
                            <div className="control">
                                <input onKeyPress={onEnter} id="password_confirm" onChange={onChangeData} 
                                className={`input ${Error.password_confirm ? 'is-danger': ''}`} type="password" placeholder="ยืนยันรหัสผ่านของท่าน" />
                            </div>
                        </div>
                        <button onClick={() => onSubmitData()} className="button is-link is-fullwidth">เปลื่ยนรหัสผ่าน</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Customer_Password;